import api from "../services/admin_api_global";

export const fetchFreeDemoRequests = (status) =>
  api.get("/admin/free-demo/requests", { params: status ? { status } : {} });

export const cancelFreeDemoRequest = (requestId) =>
  api.patch(`/admin/free-demo/requests/${requestId}/cancel`);

export const fetchFreeDemoSessions = (status) =>
  api.get("/admin/free-demo/sessions", { params: status ? { status } : {} });

export const scheduleFreeDemoSession = (data) =>
  api.post("/admin/free-demo/sessions", data);

export const rescheduleFreeDemoSession = (sessionId, data) =>
  api.post(`/admin/free-demo/sessions/${sessionId}/reschedule`, data);

export const updateFreeDemoSessionStatus = (sessionId, to) =>
  api.patch(`/admin/free-demo/sessions/${sessionId}/status?to=${to}`);
